// ** Gatsby
import { Link } from "gatsby"

// ** Custom Components
import Figure from "../Figure"
import Heading from "../Heading"
import Text from "../Text"

const BlockTypes = {
  // Customize block types with ease
  h1: ({ children }: any) => (
    <Heading as="h1" className="text-blue-500">
      {children}
    </Heading>
  ),
  h2: ({ children }: any) => (
    <Heading as="h2" className="text-blue-500">
      {children}
    </Heading>
  ),
  h3: ({ children }: any) => (
    <Heading as="h3" className="text-blue-500">
      {children}
    </Heading>
  ),
  h4: ({ children }: any) => (
    <Heading as="h4" className="text-blue-500">
      {children}
    </Heading>
  ),
  h5: ({ children }: any) => (
    <Heading as="h5" className="text-orange-500">
      {children}
    </Heading>
  ),
  h6: ({ children }: any) => (
    <Heading as="h6" className="text-blue-500">
      {children}
    </Heading>
  ),
  normal: ({ children }: any) => {
    if (children[0] === "") {
      return <br />
    }
    return (
      <Text variant="body-copy" className="mb-5">
        {children}
      </Text>
    )
  },
}

export const serializers: any = {
  block: BlockTypes,
  types: {
    image: Figure,
    media: Figure,
  },
  marks: {
    link: ({ value, children }: any) => {
      const target = (value?.href || "").startsWith("http")
        ? "_blank"
        : undefined
      return (
        <Link
          to={value?.href || ""}
          target={target}
          rel="noopener noreferrer"
          className="text-lg cursor-pointer font-bold text-blue-500 "
        >
          {children}
        </Link>
      )
    },
  },
  // paragraph: ({ children }: any) => <p className="text-lg mb-2">{children}</p>,
  list: {
    bullet: ({ children }: any) => (
      <ul className="list-disc pl-8">{children}</ul>
    ),
    number: ({ children }: any) => (
      <ol className="list-decimal pl-8">{children}</ol>
    ),
  },
  listItem: {
    bullet: ({ children }: any) => {
      return <li className="text-lg text-left">{children}</li>
    },
    number: ({ children }: any) => {
      return <li className="text-lg text-left">{children}</li>
    },
  },
}
